<template>
  <div class="slide title-card" :style="rootStyle">
    <div
      v-if="data.background_image"
      class="bg-image"
      :style="{ backgroundImage: `url(${data.background_image})` }"
    ></div>
    <div class="bg-overlay" v-if="data.background_image"></div>
    <div class="content">
      <h1 class="heading" :style="headingStyle">{{ data.heading }}</h1>
      <h2 v-if="data.subheading" class="subheading" :style="subheadingStyle">
        {{ data.subheading }}
      </h2>
      <div v-if="data.byline" class="byline">{{ data.byline }}</div>
    </div>
    <div v-if="brand" class="brand">{{ brand }}</div>
  </div>
</template>

<script>
export default {
  name: 'TitleCard',
  props: {
    data: { type: Object, required: true },
    config: { type: Object, default: () => ({}) }
  },
  computed: {
    colors() {
      return this.config.color_scheme || {}
    },
    font() {
      return this.config.font || {}
    },
    brand() {
      return this.config.brand_name || 'LearningFirst'
    },
    rootStyle() {
      return {
        background: this.colors.background || '#0F172A',
        color: this.colors.text || '#F8FAFC',
        fontFamily: this.font.body || 'Inter, system-ui, sans-serif'
      }
    },
    headingStyle() {
      return {
        color: this.colors.text || '#F8FAFC',
        fontFamily: this.font.heading || 'Inter, system-ui, sans-serif'
      }
    },
    subheadingStyle() {
      return {
        color: this.colors.accent || '#60A5FA',
        fontFamily: this.font.heading || 'Inter, system-ui, sans-serif'
      }
    }
  }
}
</script>

<style scoped>
.slide {
  width: 1920px;
  height: 1080px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.bg-image {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: blur(4px) brightness(0.4);
}
.bg-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.75) 100%);
}
.content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 1400px;
  padding: 0 80px;
}
.heading {
  font-size: 140px;
  font-weight: 800;
  line-height: 1.08;
  letter-spacing: -0.02em;
  margin: 0;
}
.subheading {
  font-size: 52px;
  font-weight: 500;
  margin: 40px 0 0;
  letter-spacing: -0.01em;
}
.byline {
  font-size: 28px;
  opacity: 0.7;
  margin-top: 48px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.brand {
  position: absolute;
  bottom: 60px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0.12em;
  opacity: 0.55;
  z-index: 2;
}
</style>
